import { jobWorkActionTypes } from '@Actions/production/jobWorkActions';

const JobWorkReducers = (state = {
  kanbanJobWorks: {
    machine: {
      loading: false,
      bottomLoading: false,
    },
    work_center: {
      loading: false,
      bottomLoading: false,
    },
    operator: {
      loading: false,
      bottomLoading: false,
    },
  },
}, action) => {
  switch (action.type) {
  case jobWorkActionTypes.JOB_WORKS.LOADING: {
    const { getJobWorksLoading } = action;
    return {
      ...state,
      getJobWorksLoading,
    };
  }
  case jobWorkActionTypes.JOB_WORKS.SUCCESS: {
    const { jobWorks } = action;
    return {
      ...state,
      jobWorks,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_MO_ID.LOADING: {
    const { getJobWorkByMoIdLoading } = action;
    return {
      ...state,
      getJobWorkByMoIdLoading,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_MO_ID.SUCCESS: {
    const { moJobWork } = action;
    return {
      ...state,
      moJobWork,
    };
  }
  case jobWorkActionTypes.UPDATE_JOB_WORK.LOADING: {
    const { updateJobWorkLoading } = action;
    return {
      ...state,
      updateJobWorkLoading,
    };
  }

  case jobWorkActionTypes.GET_JOB_OPERATORS.LOADING: {
    const { getJobOperatorsLoading } = action;
    return {
      ...state,
      getJobOperatorsLoading,
    };
  }

  case jobWorkActionTypes.GET_JOB_OPERATORS.SUCCESS: {
    const { jobOperators } = action;
    return {
      ...state,
      jobOperators,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN.LOADING: {
    const { getJobWorksKanbanLoading } = action;
    return {
      ...state,
      getJobWorksKanbanLoading,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN.SUCCESS: {
    const { groupBy, jobWorks } = action;
    const { kanbanJobWorks } = state;
    const kanbanJobWorksCopy = JSON.parse(JSON.stringify(kanbanJobWorks));
    const newJobWorks = {
      ...jobWorks,
      job_works: jobWorks?.job_works?.map((item) => ({
        ...item,
        page: 1,
        previousPage: 0,
        limit: 100,
      })),
    };
    kanbanJobWorksCopy[groupBy] = {
      ...kanbanJobWorksCopy[groupBy],
      ...newJobWorks,
    };
    return {
      ...state,
      kanbanJobWorks: kanbanJobWorksCopy,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.LOADING: {
    const { groupBy, getJobWorksKanbanPageLoading } = action;
    const { kanbanJobWorks } = state;
    const kanbanJobWorksCopy = JSON.parse(JSON.stringify(kanbanJobWorks));
    kanbanJobWorksCopy[groupBy].bottomLoading = getJobWorksKanbanPageLoading;
    return {
      ...state,
      kanbanJobWorks: kanbanJobWorksCopy,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.SUCCESS: {
    const {
      groupBy, jobWorks, previousPage, page, groupName, count,
    } = action;
    const { kanbanJobWorks } = state;
    const kanbanJobWorksCopy = JSON.parse(JSON.stringify(kanbanJobWorks));
    for (let i = 0; i < kanbanJobWorksCopy[groupBy]?.job_works?.length; i++) {
      if (kanbanJobWorksCopy[groupBy]?.job_works[i]?.group_name === groupName) {
        kanbanJobWorksCopy[groupBy].job_works[i].page = page;
        kanbanJobWorksCopy[groupBy].job_works[i].previousPage = previousPage;
        if (page == 1) {
          kanbanJobWorksCopy[groupBy].job_works[i].count = count;
          kanbanJobWorksCopy[groupBy].job_works[i].job_works = jobWorks;
        } else {
          kanbanJobWorksCopy[groupBy].job_works[i].job_works = [...kanbanJobWorksCopy[groupBy].job_works[i].job_works, ...jobWorks];
        }
      }
    }
    return {
      ...state,
      kanbanJobWorks: kanbanJobWorksCopy,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_ID.LOADING: {
    const { getJobWorkByIdLoading } = action;
    return {
      ...state,
      getJobWorkByIdLoading,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_ID.SUCCESS: {
    const { selectedJobWork } = action;
    return {
      ...state,
      selectedJobWork,
    };
  }
  case jobWorkActionTypes.PROCESS_JW_MATERIAL.LOADING: {
    const { processJwMaterialLoading } = action;
    return {
      ...state,
      processJwMaterialLoading,
    };
  }
  case jobWorkActionTypes.PROCESS_JW_MATERIAL_COMPLETE.LOADING: {
    const { processJwMaterialCompleteLoading } = action;
    return {
      ...state,
      processJwMaterialCompleteLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default JobWorkReducers;
